module.exports = __webpack_public_path__ + "img/75673.2a015d18.svg";